import * as actions from "../action.constants";

const initialState = {
  inventoryReportsData: {},
};

const saveInventoryReports = (state, action) => ({
  ...state,
  inventoryReportsData: action.payload,
});

const handlers = {
  [actions.STORE_INVENTORY_REPORTS]: saveInventoryReports,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
